/*
 * Kalon recommendation library (Oct 2026). Shared by the homepage "Picked for you" section and the
 * product-page "Complete the look" / "More like this" rows.
 * Everything runs in the visitor's browser on her own history (window.KalonReco, see kalon-reco-tracker).
 */
(function () {
  if (window.KalonRecoLib) return;
  var DAY = 864e5;
  var W = { add: 4, search: 3, dwell: 2, clk: 1.5, view: 1, coll: 0.6 };

  /* Canonical categories. Product types in the store are inconsistent ("High Heels", "HEELS", "heels", blank),
     so we map type, then title, onto one code. */
  var CAT_HANDLE = { W: 'wrist-watches', H: 'high-heels', B: 'handbags', S: 'slipper-slides', K: 'sneakers-canvas', L: 'boots-loafers', T: 'waist-belt', G: 'eyewear', J: 'jewellery', A: 'outfits', P: 'handbags' };
  var CAT_NAME = { W: 'watches', H: 'heels', B: 'bags', S: 'slippers', K: 'sneakers', L: 'boots', T: 'belts', G: 'sunglasses', J: 'jewellery', A: 'outfits', P: 'wallets' };
  function match(s) {
    s = ' ' + String(s || '').toLowerCase() + ' ';
    if (/watch/.test(s)) return 'W';
    if (/wallet|money bag|card holder/.test(s)) return 'P';
    if (/heel|stiletto|pump/.test(s)) return 'H';
    if (/slipper|slide|flip.?flop/.test(s)) return 'S';
    if (/sneaker|canvas|samba/.test(s)) return 'K';
    if (/boot|loafer/.test(s)) return 'L';
    if (/belt/.test(s)) return 'T';
    if (/sunglass|eyewear|glasses/.test(s)) return 'G';
    if (/necklace|bracelet|earring|[^a-z]rings?[^a-z]|jewel|hair|pendant|anklet/.test(s)) return 'J';
    if (/skirt|[^a-z]tops?[^a-z]|dress|pant|shirt|blouse|outfit/.test(s)) return 'A';
    if (/bag|clutch|purse|tote/.test(s)) return 'B';
    return '';
  }
  function canon(type, title) { return match(type) || match(title) || ''; }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clean(t) { return String(t || '').replace(/\((pre-?book|pre-order|in stock)\)/ig, '').replace(/^\s*kalonbd\s+/i, '').replace(/\s+/g, ' ').trim(); }
  function isPre(p) { return /pre-?book|pre-order/i.test(p.rawTitle || p.title || ''); }
  function money(cents, fmt) {
    var n = Number(cents) / 100;
    var two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || ('Tk ' + '{' + '{amount}' + '}');
    return String(fmt).replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return none;
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return two;
    });
  }
  function sized(url, w) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    url = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(url) { return [300, 450, 600].map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', '); }
  function getJSON(url, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, ms || 3500);
    return fetch(url, { headers: { Accept: 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(timer); if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function () { clearTimeout(timer); return null; });
  }

  /* Normalise the product shapes Shopify returns */
  function norm(p) { p.title = clean(p.rawTitle); p.cat = p.cat || canon(p.type, p.rawTitle); return p; }
  function fromAjax(p) {
    if (!p) return null;
    var imgs = (p.images || []).map(function (i) { return typeof i === 'string' ? i : (i && i.src); });
    var fi = p.featured_image; if (fi && typeof fi === 'object') fi = fi.url || fi.src;
    return norm({ id: p.id, handle: p.handle, rawTitle: p.title, type: p.type || p.product_type || '', price: Number(p.price), compare: Number(p.compare_at_price || 0), img: fi || imgs[0], img2: imgs[1] || null, url: p.url || ('/products/' + p.handle), available: p.available !== false });
  }
  function fromSuggest(p) {
    if (!p) return null;
    return norm({ id: p.id, handle: p.handle, rawTitle: p.title, type: p.type || '', price: Math.round(parseFloat(p.price) * 100), compare: Math.round(parseFloat(p.compare_at_price_max || 0) * 100), img: (p.featured_image && p.featured_image.url) || p.image, img2: null, url: p.url, available: p.available !== false });
  }
  function fromCollectionJSON(p) {
    if (!p) return null;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    var imgs = (p.images || []).map(function (i) { return i.src; });
    return norm({ id: p.id, handle: p.handle, rawTitle: p.title, type: p.product_type || '', price: Math.round(parseFloat(v.price || 0) * 100), compare: Math.round(parseFloat(v.compare_at_price || 0) * 100), img: imgs[0], img2: imgs[1] || null, url: '/products/' + p.handle, available: (p.variants || []).some(function (x) { return x.available; }) });
  }
  function fromPool(p) {
    return norm({ id: p.id, handle: p.handle, rawTitle: p.title, type: p.type, cat: p.cat, price: p.price, compare: p.compare, img: p.img, img2: p.img2, url: p.url, available: true });
  }

  /* Visitor profile from on-device history: time-decayed interest (half-life 7 days) plus implicit negative feedback */
  function profile() {
    var NOW = Date.now();
    var store = (window.KalonReco && window.KalonReco.load()) || { events: [] };
    var events = (store.events || []).filter(function (e) { return e && e.t && NOW - e.t < 60 * DAY; });
    var P = { now: NOW, has: events.length > 0, prod: {}, catAff: {}, maxCat: 1e-9, mainCat: '', terms: {}, colls: {}, lastSeen: {}, added: {}, clicked: {}, bounced: {}, imp: store.imp || {}, median: null };
    var prices = [];
    events.forEach(function (e) {
      var d = Math.pow(0.5, (NOW - e.t) / (7 * DAY));
      var w = (W[e.k] || 0) * d;
      if (e.k === 'bounce' && e.h) { P.bounced[e.h] = (P.bounced[e.h] || 0) + 1; return; }
      if (e.k === 'clk' && e.h) P.clicked[e.h] = true;
      if (e.h && e.k !== 'search' && e.k !== 'coll') {
        var r = P.prod[e.h] || (P.prod[e.h] = { h: e.h, s: 0 });
        r.s += w; if (e.id) r.id = e.id; if (e.ti) r.ti = e.ti; if (e.pr) r.pr = e.pr;
        var c = e.ca || canon(e.ty, e.ti); if (c) r.ca = c;
        if (e.k !== 'clk' && (!P.lastSeen[e.h] || e.t > P.lastSeen[e.h])) P.lastSeen[e.h] = e.t;
        if (e.k === 'add') P.added[e.h] = true;
        if (r.ca) P.catAff[r.ca] = (P.catAff[r.ca] || 0) + w;
        if (e.pr) prices.push({ v: e.pr, w: w });
      }
      if (e.k === 'search' && e.q) { var q = String(e.q).toLowerCase().trim(); P.terms[q] = (P.terms[q] || 0) + w; }
      if (e.k === 'coll' && e.c) { var cc = P.colls[e.c] || (P.colls[e.c] = { h: e.c, ti: e.ti, s: 0 }); cc.s += w; }
    });
    Object.keys(P.catAff).forEach(function (k) { if (P.catAff[k] > P.maxCat) { P.maxCat = P.catAff[k]; P.mainCat = k; } });
    if (prices.length) {
      prices.sort(function (a, b) { return a.v - b.v; });
      var half = prices.reduce(function (s, p) { return s + p.w; }, 0) / 2, acc = 0;
      for (var i = 0; i < prices.length; i++) { acc += prices[i].w; if (acc >= half) { P.median = prices[i].v; break; } }
    }
    return P;
  }
  function seeds(P, n) {
    return Object.keys(P.prod).map(function (k) { return P.prod[k]; }).filter(function (p) { return p.id; }).sort(function (a, b) { return b.s - a.s; }).slice(0, n);
  }
  /* log-normal closeness of two prices (1 = same price) */
  function priceClose(a, b, sigma) {
    if (!a || !b) return 0.5;
    var x = Math.log(a / b);
    return Math.exp(-(x * x) / (2 * sigma * sigma));
  }
  /* Implicit negative feedback: shown 3+ times and never clicked, or clicked and left within 8 seconds */
  function negative(P, h) {
    var pen = 0, im = P.imp[h];
    var n = im ? im[0] : 0;
    if (n >= 3 && !P.clicked[h] && !P.added[h]) pen += Math.min(0.3, 0.06 * (n - 2));
    if (P.bounced[h]) pen += 0.25;
    return pen;
  }
  function jitter(h, now) {
    var s = 0, str = h + Math.floor(now / DAY);
    for (var i = 0; i < str.length; i++) s = (s * 31 + str.charCodeAt(i)) % 1000;
    return (s / 1000 - 0.5) * 0.06;
  }
  function band(price) { return price ? Math.round(Math.log(price / 100) / Math.log(1.6)) : -1; }
  function tokens(t) {
    var stop = { the: 1, and: 1, for: 1, with: 1, women: 1, womens: 1, new: 1, bag: 1, bags: 1 };
    return String(t || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').split(' ').filter(function (w) { return w.length > 2 && !stop[w]; });
  }
  function jaccard(a, b) {
    if (!a.length || !b.length) return 0;
    var sa = {}, inter = 0, uni = {};
    a.forEach(function (w) { sa[w] = 1; uni[w] = 1; });
    b.forEach(function (w) { if (sa[w]) inter++; uni[w] = 1; });
    return inter / Object.keys(uni).length;
  }
  /* Maximal Marginal Relevance (Carbonell & Goldstein, 1998): pick by relevance minus similarity to what is already picked.
     When the candidates span 3+ categories, no category may take more than 3 of 8 slots (scaled to the row size). */
  function mmr(list, limit, lambda, sim) {
    var chosen = [], pool = list.slice(), per = {}, cats = {};
    list.forEach(function (c) { if (c.p && c.p.cat) cats[c.p.cat] = 1; });
    var cap = Object.keys(cats).length >= 3 ? Math.max(2, Math.ceil(limit * 0.375)) : Infinity;
    while (chosen.length < limit && pool.length) {
      var bi = -1, bv = -Infinity;
      for (var i = 0; i < pool.length; i++) {
        var k = pool[i].p && pool[i].p.cat;
        if (k && (per[k] || 0) >= cap) continue;
        var m = 0;
        for (var j = 0; j < chosen.length; j++) m = Math.max(m, sim(pool[i], chosen[j]));
        var v = pool[i].rel - lambda * m;
        if (v > bv) { bv = v; bi = i; }
      }
      if (bi < 0) { cap = Infinity; continue; } /* not enough variety left: fill the row */
      var pick = pool.splice(bi, 1)[0];
      if (pick.p && pick.p.cat) per[pick.p.cat] = (per[pick.p.cat] || 0) + 1;
      chosen.push(pick);
    }
    return chosen;
  }

  var SIZES = '(min-width: 1000px) 22vw, (min-width: 700px) 31vw, 48vw';
  function card(c, fmt, cls) {
    var p = c.p, sale = p.compare && p.compare > p.price;
    var img2 = p.img2 ? '<img class="kr__img kr__img--2" src="' + esc(sized(p.img2, 600)) + '" srcset="' + esc(srcset(p.img2)) + '" sizes="' + SIZES + '" alt="" loading="lazy">' : '';
    return '<li class="kr__card' + (cls ? ' ' + cls : '') + '" data-reco-h="' + esc(p.handle) + '">' +
      '<a class="kr__media" href="' + esc(p.url) + '">' +
        '<img class="kr__img" src="' + esc(sized(p.img, 600)) + '" srcset="' + esc(srcset(p.img)) + '" sizes="' + SIZES + '" alt="' + esc(p.title) + '" loading="lazy">' + img2 +
        (isPre(p) ? '<span class="kr__badge">Pre-book</span>' : '') +
      '</a><div class="kr__body">' +
        '<a class="kr__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="kr__price' + (sale ? ' is-sale' : '') + '">' + esc(money(p.price, fmt)) + (sale ? '<s>' + esc(money(p.compare, fmt)) + '</s>' : '') + '</span>' +
        (c.why ? '<span class="kr__why">' + esc(c.why) + '</span>' : '') +
      '</div></li>';
  }
  function cartHandles(base) {
    return getJSON(base + 'cart.js', 2500).then(function (c) { var o = {}; ((c && c.items) || []).forEach(function (i) { o[i.handle] = true; }); return o; });
  }
  /* Run fn when el is near the screen; safety net: run anyway shortly after the page has loaded
     (some phones and background tabs pause IntersectionObserver). fn runs once. */
  function whenNear(el, fn, margin) {
    var done = false;
    function go() { if (done) return; done = true; if (io) io.disconnect(); fn(); }
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) go(); }, { rootMargin: (margin || 800) + 'px 0px' });
      io.observe(el);
    }
    function later() { setTimeout(go, 2500); }
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  }

  window.KalonRecoLib = {
    CAT_HANDLE: CAT_HANDLE, CAT_NAME: CAT_NAME, canon: canon, esc: esc, clean: clean, isPre: isPre, money: money, sized: sized, srcset: srcset,
    getJSON: getJSON, fromAjax: fromAjax, fromSuggest: fromSuggest, fromCollectionJSON: fromCollectionJSON, fromPool: fromPool,
    profile: profile, seeds: seeds, priceClose: priceClose, negative: negative, jitter: jitter, band: band, tokens: tokens, jaccard: jaccard,
    mmr: mmr, card: card, cartHandles: cartHandles, whenNear: whenNear
  };
})();
